<template>
	<div>
		<v-btn
			v-if="state === 'active_paused_active'" 
			:small="inTable" 
			depressed 
			:min-width="inTable ? 65:120" 
			:max-width="inTable ? 65:120"
			:color="inTable ? '#82899B':'rgba(129, 204, 0, 0.1)'" 
			:class="inTable ? 'white--text':'text-capitalize'" 
			:style="inTable ? '':'color: #609800'"
			@click.stop="do_start()">
			{{ startText }}
		</v-btn>
		<v-btn
			v-if="state === 'active_running'"
			@mouseover="isHover = true"
			@mouseout="isHover = false"
			:small="inTable"
			depressed
			:min-width="inTable ? 65:120" 
			:max-width="inTable ? 65:120"
			color="#F45252"
			class="white--text" 
			@click.stop="do_stop()">
			<span v-if="!isHover">STOP</span>
			<span v-else class="text-capitalize">{{ time_text }}</span>
		</v-btn>
		<v-btn v-if="state === 'unknown'" :small="inTable" depressed disabled :min-width="inTable ? 65:128" :max-width="inTable ? 65:128" color="rgba(25, 42, 62, 0.15)" class="white--text text-capitalize">
			<span>{{ inTable ? 'Disabled':'Timer disabled'}}</span>
		</v-btn>
	</div>
</template>

<script>
export default {
	props: {
		recording: {
			type: Boolean,
			default: false
		},
		active: {
			type: Boolean,
			default: false
		},
		status_type: {
			type: Number,
			default: 0
		},
		inTable: {
			type: Boolean,
			default: true
		},
		startText: {
			type: String,
			default: 'START'
		},
		color: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			isHover: false,
			time_text: ''
		}
	},
	computed: {
		state() {
			let state_tmp = 'unknown';

			if (this.status_type === 2) {
				if (this.recording) {
					state_tmp = 'active_running';
				}
				if (this.active) {
					state_tmp = 'active_paused_active';
				}
			}

			return state_tmp;
		}
	},
	watch: {
		isHover() {
			if (this.isHover) {
				this.getTimeText();
			}
		}
	},
	methods: {
		getTimeText() {
			const new_time = new Date().getTime();
			const time_passed_in_ms = new_time - this.$store.state.recording.started;
			const time_passed_in_mins = Math.round(time_passed_in_ms / 60000.0);

			const hours_passed = Math.floor(time_passed_in_mins / 60.0);
			const minutes_passed = time_passed_in_mins - (hours_passed * 60);

			this.time_text = `${hours_passed}h ${minutes_passed}m`;
		},
		do_start() {
			this.$emit('start');
		},
		do_stop() {
			this.$emit('stop');
		}
	}
}
</script>

